import { GoalOverviewRoadmapViewOptions } from './goal-overview';
import { TimelineTimeframes } from './timeline-timeframes';

// Selects which platform's fields a roadmap-settings consumer reads/writes.
// Never persisted — code-level selector only.
export enum RoadmapPlatform {
  Web = 'web',
  Mobile = 'mobile',
}

// Per-platform roadmap (list/timeline) preferences, shared by entities that
// expose a roadmap view (goals, life areas). Per-platform like
// user.settings.goalsOverview so web and mobile choices stay independent.
export type RoadmapViewSettings = {
  webView?: GoalOverviewRoadmapViewOptions;
  mobileView?: GoalOverviewRoadmapViewOptions;
  webTimeframe?: TimelineTimeframes;
  mobileTimeframe?: TimelineTimeframes;
};
